/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Superset_Mixed_DaysInputs */

const en_us2_plan_superset_mixed_days = /** @type {(inputs: Plan_Superset_Mixed_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A superset groups exercises of the same workout.`)
};

const pt_br2_plan_superset_mixed_days = /** @type {(inputs: Plan_Superset_Mixed_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um superset junta exercícios do mesmo treino.`)
};

const es_419_plan_superset_mixed_days = /** @type {(inputs: Plan_Superset_Mixed_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una superserie agrupa ejercicios del mismo entrenamiento.`)
};

const pt_pt2_plan_superset_mixed_days = /** @type {(inputs: Plan_Superset_Mixed_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um superset junta exercícios do mesmo treino.`)
};

const fr_fr2_plan_superset_mixed_days = /** @type {(inputs: Plan_Superset_Mixed_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un superset regroupe des exercices de la même séance.`)
};

const de_de2_plan_superset_mixed_days = /** @type {(inputs: Plan_Superset_Mixed_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Supersatz fasst Übungen desselben Trainings zusammen.`)
};

const it_it2_plan_superset_mixed_days = /** @type {(inputs: Plan_Superset_Mixed_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un superset raggruppa esercizi dello stesso allenamento.`)
};

/**
* | output |
* | --- |
* | "A superset groups exercises of the same workout." |
*
* @param {Plan_Superset_Mixed_DaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_superset_mixed_days = /** @type {((inputs?: Plan_Superset_Mixed_DaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Superset_Mixed_DaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_superset_mixed_days(inputs)
	if (locale === "es-419") return es_419_plan_superset_mixed_days(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_superset_mixed_days(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_superset_mixed_days(inputs)
	if (locale === "de-DE") return de_de2_plan_superset_mixed_days(inputs)
	if (locale === "it-IT") return it_it2_plan_superset_mixed_days(inputs)
	return en_us2_plan_superset_mixed_days(inputs)
});
export { plan_superset_mixed_days as "plan.superset_mixed_days" }